import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SIMCompatibilityWarning } from "../../components/Mobile/SIMCompatibilityWarning";
import { confirmSIMCompatibilityWarning } from "../../../../store/mobile/actions";
import { getAffectedNumbers } from "../../../../store/mobile/selectors/productConfig";

export const SIMCompatibilityWarningContainer = () => {
  const dispatch = useDispatch();
  const showSIMCompatibilityWarning = useSelector<any, boolean>(
    (state) => state.mobile.showSIMCompatibilityWarning
  );
  const handleConfirm = () => {
    dispatch(confirmSIMCompatibilityWarning());
  };

  const affectedNumbers = useSelector((state: any) =>
    getAffectedNumbers(state)
  );

  return affectedNumbers.length > 0 ? (
    <SIMCompatibilityWarning
      show={showSIMCompatibilityWarning}
      handleConfirm={handleConfirm}
      affectedNumbers={affectedNumbers}
    />
  ) : null;
};
